import { render, staticRenderFns } from "./MonthSalesColumn.vue?vue&type=template&id=03467160&scoped=true"
import script from "./MonthSalesColumn.vue?vue&type=script&lang=js"
export * from "./MonthSalesColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03467160",
  null
  
)

export default component.exports